import PageTitle from "components/PageTitle/PageTitle";
import PageFrame from "components/Panels/PageFrame";
import VaultCashView from "./VaultCashView";

const VaultCashService = () => {
  return (
    <PageFrame
      children={
        <div>
          <PageTitle titleText="시재금 관리" />
          <VaultCashView />
        </div>
      }
    />
  );
};
export default VaultCashService;
